import React, { useEffect } from "react";
import { useBeam } from "@randajan/bifrost/client/react";
import { Block } from "@randajan/jet-react/dom/block";

import { meBeam } from "../../assets/beams/meBeam";
import { page } from "../../assets/bases/page";
import { Profile } from "../../frames/Profile/Profile";

import "./Me.scss";
import { usePagePop } from "../../frames/PagePops/PagePops";

export const Me = _=>{
    const { data:user, status } = useBeam(meBeam);
    const loginPop = usePagePop("login");

    useEffect(_=>{
        if (loginPop && status != "pull" && !user) {
            loginPop.up({onDown:_=>{ page.set("pathname", "/") }});
        }
    }, [loginPop, status, user]);

    return <Profile className="Me" showMe/>;
};
